<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" defaultHref="accounts"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">New Account</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>
            <ion-item-divider color="secondary">
                Dealership Information
            </ion-item-divider>

            <ion-item>
                <ion-label position="stacked">Dealership Name</ion-label>
                <ion-input data-test="dealershipName" color="secondary" type="text" name="dealershipName"
                    #dealershipName="ngModel" required
                    [ngClass]="{ 'is-invalid': f.submitted && dealershipName.invalid }" [(ngModel)]="vm.dealershipName"
                    id="dealershipName" placeholder="Required.">
                </ion-input>
                @if (submitted && dealershipName.invalid) {
                <div>
                    <div class="errorMsg">Dealership name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Country</ion-label>
                <ion-input data-test="countryName" color="secondary" type="text" name="countryName"
                    #countryName="ngModel" required [ngClass]="{ 'is-invalid': f.submitted && countryName.invalid }"
                    [(ngModel)]="vm.countryName" id="countryName" placeholder="Required." (click)="onCountryClick()">
                </ion-input>
                <!-- @if (submitted && countryName.invalid) {
  <div>
                    <div class="errorMsg">Country is required.</div>
                </div>
} -->

                <ion-buttons class="itemButtons" slot="end">
                    <ion-button data-test="countrySearchButton" class="countryButton" color="primary" expand="full"
                        fill="solid" id="eye" (click)="onCountryClick()">
                        <ion-icon name="search"></ion-icon>
                    </ion-button>
                </ion-buttons>
                @if (submitted && countryName.invalid) {
                <div>
                    <div class="errorMsg">Country is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">State or Region</ion-label>
                <ion-input data-test="regionName" color="secondary" type="text" name="regionName" #regionName="ngModel"
                    required readonly [ngClass]="{ 'is-invalid': f.submitted && regionName.invalid }"
                    [(ngModel)]="vm.regionName" id="regionName" placeholder="Required.">
                </ion-input>

                <ion-buttons class="itemButtons" slot="end">
                    <ion-button data-test="regionSearchButton" class="regionNameButton" color="primary" expand="full"
                        fill="solid" id="eye" (click)="onRegionNameClick()">
                        <ion-icon name="search"></ion-icon>
                    </ion-button>
                </ion-buttons>
                @if (submitted && regionName.invalid) {
                <div>
                    <div class="errorMsg">State is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Timezone</ion-label>
                <ion-input data-test="timezone" color="secondary" type="text" name="timezoneCaption" required readonly
                    #timezoneCaption="ngModel" [(ngModel)]="vm.timezone.caption"
                    [ngClass]="{ 'is-invalid': f.submitted && timezoneCaption.invalid }" id="timezone"
                    placeholder="Required.">
                </ion-input>

                <ion-buttons class="itemButtons" slot="end">
                    <ion-button data-test="timezoneSearchButton" class="timezoneButton" color="primary" expand="full"
                        fill="solid" id="eye" (click)="onTimezoneClick()">
                        <ion-icon name="search"></ion-icon>
                    </ion-button>
                </ion-buttons>
                @if (submitted && timezoneCaption.invalid) {
                <div>
                    <div class="errorMsg">Timezone is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Phone Number</ion-label>
                <ion-input color="secondary" type="tel" appPhoneMask placeholder="(xxx) xxx-xxxx" #phoneNumber="ngModel"
                    minlength="14" maxlength="14" name="phoneNumber"
                    [ngClass]="{'is-invalid': f.submitted && phoneNumber.invalid}" required [(ngModel)]="vm.phoneNumber"
                    id="phoneNumber" data-test="phoneNumber">
                </ion-input>
                @if (submitted && phoneNumber.invalid) {
                <div data-test="phoneNumberErr">
                    <div class="validationErrorMsg">Phone number is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Street Address</ion-label>
                <ion-input data-test="streetAddress" color="secondary" type="text" name="streetAddress"
                    [(ngModel)]="vm.streetAddress" #streetAddress="ngModel" required placeholder="Example: 123 Main St"
                    [ngClass]="{ 'is-invalid': f.submitted && streetAddress.invalid }">
                </ion-input>
                @if (submitted && streetAddress.invalid) {
                <div>
                    <div class="validationErrorMsg">Street Address is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">City</ion-label>
                <ion-input data-test="city" id="city" color="secondary" type="text" name="city" [(ngModel)]="vm.city"
                    required #city="ngModel" [ngClass]="{ 'is-invalid': f.submitted && city.invalid }">
                </ion-input>
                @if (submitted && city.invalid) {
                <div>
                    <div class="validationErrorMsg">City is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Zipcode</ion-label>
                <ion-input data-test="zipcode" id="zipcode" color="secondary" type="number" name="zipcode"
                    [(ngModel)]="vm.zipcode" required #zipcode="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && zipcode.invalid }" (ionChange)="onZipcodeChange()">
                </ion-input>
                @if (submitted && zipcode.invalid) {
                <div>
                    <div class="validationErrorMsg">Zipcode is required.</div>
                </div>
                }
            </ion-item>


            <br />
            <ion-item-divider color="secondary">
                Manager's Information
            </ion-item-divider>

            <ion-item>
                <ion-label position="stacked">Manager's First Name</ion-label>
                <ion-input data-test="firstName" color="secondary" type="text" name="firstName" #firstName="ngModel"
                    required [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" [(ngModel)]="vm.firstName"
                    id="firstName" placeholder="Required.">
                </ion-input>
                @if (submitted && firstName.invalid) {
                <div>
                    <div class="errorMsg">Manager's first name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Manager's Last Name</ion-label>
                <ion-input data-test="lastName" color="secondary" type="text" name="lastName" #lastName="ngModel"
                    required [ngClass]="{ 'is-invalid': f.submitted && lastName.invalid }" [(ngModel)]="vm.lastName"
                    id="lastName" placeholder="Required.">
                </ion-input>
                @if (submitted && lastName.invalid) {
                <div>
                    <div class="errorMsg">Manager's last name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Cell Phone</ion-label>
                <ion-input color="secondary" type="tel" appPhoneMask placeholder="(xxx) xxx-xxxx" #cellPhone="ngModel"
                    minlength="14" maxlength="14" name="cellPhone"
                    [ngClass]="{'is-invalid': f.submitted && cellPhone.invalid}" required [(ngModel)]="vm.cellPhone"
                    id="cellPhone" data-test="cellPhone">
                </ion-input>
                @if (submitted && cellPhone.invalid) {
                <div data-test="cellPhoneErr">
                    <div class="validationErrorMsg">Cell phone is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Email</ion-label>
                <ion-input data-test="email" color="secondary" type="email" name="email" #email="ngModel" required
                    [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" [(ngModel)]="vm.email" id="email"
                    placeholder="Required.">
                </ion-input>
                @if (submitted && email.invalid) {
                <div>
                    <div class="errorMsg">Email address is required.</div>
                </div>
                }
            </ion-item>

            <br />
            <ion-item-divider color="secondary">
                Affiliate and Coupon Information
            </ion-item-divider>

            <ion-item>
                <ion-label position="stacked">Affiliate Id</ion-label>
                <ion-input data-test="affiliateId" color="secondary" type="text" name="affiliateId"
                    #affiliateId="ngModel" required [ngClass]="{ 'is-invalid': f.submitted && affiliateId.invalid }"
                    [(ngModel)]="vm.affiliateId" id="affiliateId">
                </ion-input>
                @if (submitted && affiliateId.invalid) {
                <div>
                    <div class="errorMsg">Enter the affiliate id.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Coupon Code</ion-label>
                <ion-input data-test="couponCode" color="secondary" type="text" name="couponCode" #couponCode="ngModel"
                    required [ngClass]="{ 'is-invalid': f.submitted && couponCode.invalid }" [(ngModel)]="vm.couponCode"
                    id="couponCode" placeholder="Typically of the form: xxxx-xxxxxx">
                </ion-input>
                @if (submitted && couponCode.invalid) {
                <div>
                    <div class="errorMsg">Enter the coupon code.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Account Number</ion-label>
                <ion-input data-test="accountNumber" color="secondary" type="text" [(ngModel)]="vm.accountNumber"
                    placeholder="NNNNN-NNNN-NNNNN" name="accountNumber">
                </ion-input>
            </ion-item>

            <!-- <br />
            <ion-item-divider color="secondary">
                Features
            </ion-item-divider>

            <ion-item class="ion-no-padding">
                <ion-label>
                    <span class="line1">Efficiency</span><br />
                    <span class="line2">{{vm.efficiencyDesc}}</span>
                </ion-label>
                <ion-toggle name="efficiency" [(ngModel)]="vm.packageFeatures.efficiency" disabled
                    (ionChange)="onToggleEfficiencyClick()"></ion-toggle><br />
            </ion-item>

            <ion-item class="ion-no-padding">
                <ion-label>
                    <span class="line1">Customer</span><br />
                    <span class="line2">{{vm.packageFeatures.customerStr}}</span>
                </ion-label>
                <ion-toggle name="customer" [(ngModel)]="vm.packageFeatures.customer" disabled>
                </ion-toggle><br />
            </ion-item>

            <ion-item class="ion-no-padding">
                <ion-label>
                    <span class="line1">Campaign</span><br />
                    <span class="line2">{{vm.packageFeatures.campaignStr}}</span>
                </ion-label>
                <ion-toggle name="campaign" [(ngModel)]="vm.packageFeatures.campaign" disabled>
                </ion-toggle><br />
            </ion-item> -->
            <!-- 
            <br />
            <ion-item-divider color="secondary">
                Response
            </ion-item-divider>

            <ion-item>
                <ion-label position="stacked">Claims</ion-label>
                <ion-input type="text" name="claims" [(ngModel)]="vm.claims" readonly data-test="claims" ></ion-input>
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Password</ion-label>
                <ion-input type="text" name="password" [(ngModel)]="vm.password" data-test="password" readonly></ion-input>
            </ion-item>
 -->
        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-button data-test="validateAddressButton" color="primary" expand="full"
                        (click)="onValidateAddressClick()" [disabled]="!f.valid">
                        Validate Address
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button data-test="saveButton" color="primary" expand="full" (click)="onSaveClick(f)"
                        [disabled]="!vm.addressVerified">
                        Save
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-footer>